import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Tabs } from 'antd';
import { ToolOutlined, SafetyOutlined, ApiOutlined } from '@ant-design/icons';
import { AdminAccountModel } from './AdminAccountModel';
import { AdminAccountROView } from './RO/AdminAccountROView';
import { AdminAccountROModel } from './RO/AdminAccountROModel';
import { AdminAccountFIView } from './FI/AdminAccountFIView';
import { AdminAccountFIModel } from './FI/AdminAccountFIModel';
import { AdminAccountIntegrationsModel } from './Integrations/AdminAccountIntegrationsModel';
import { AdminAccountIntegrationsView } from './Integrations/AdminAccountIntegrationsView';

interface AdminAccountViewProps {
  model: AdminAccountModel;
}

const { TabPane } = Tabs;

export const AdminAccountView: React.FC<AdminAccountViewProps> = observer(({ model }) => {
  const roModel = new AdminAccountROModel(model.accountId);
  const fiModel = new AdminAccountFIModel(model.accountId);
  const integrationsModel = new AdminAccountIntegrationsModel(model.accountId);

  useEffect(() => {
    roModel.refresh();
    fiModel.refresh();
    integrationsModel.refresh();
  }, [roModel, fiModel, integrationsModel]);

  return (
    <div className="admin-accounts">
      <Tabs defaultActiveKey="1">
        <TabPane
          tab={<><ToolOutlined />Repair Orders</>}
          key="1"
        >
          <AdminAccountROView model={roModel} />
        </TabPane>
        <TabPane
          tab={<><SafetyOutlined />Finance and Insurance</>}
          key="2"
        >
          <AdminAccountFIView model={fiModel} />
        </TabPane>
        <TabPane
          tab={<><ApiOutlined />Integrations</>}
          key="3"
        >
          <AdminAccountIntegrationsView model={integrationsModel} />
        </TabPane>
      </Tabs>
    </div>
  );
});
